module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("THANKS TO")]), _vm._v(" Alisha Klauger and Christine DeLuna for reading early drafts and letting me know when I was on the right track and on the wrong one.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Thanks to the real Julia Madden for being my sister.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("As always thanks to Danny, Drew, Justin, Matthew, Vita, Emma, and Carson, just because.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Many, many thanks to everyone at Harmony Ink and Dreamspinner: Anne, Dawn, Jaime, Janet, and everyone there. Thank you. Thank you. Thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-989ad52c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0004.vue
// module id = 66
// module chunks = 0